var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M198.11,152v66.62c0,4.7-3.81,8.5-8.5,8.5H24.48 c-4.7,0-8.5-3.81-8.5-8.5V26.95c0-4.7,3.81-8.5,8.5-8.5H189.6c4.7,0,8.5,3.81,8.5,8.5v67.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M198.11,152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M198.11,94.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M198.11,67.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M27.68,23.19l80.67,32.7 c3.21,1.3,5.31,4.42,5.31,7.88v194.07c0,6.03-6.11,10.15-11.7,7.88l-80.67-32.7c-3.21-1.3-5.31-4.42-5.31-7.88V31.07 C15.98,25.03,22.09,20.92,27.68,23.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M216.23,132.65h-74.54 c-3.13,0-5.67-2.54-5.67-5.67v-8.38c0-3.13,2.54-5.67,5.67-5.67h74.54V132.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M231.65,85.26l33.82,33.82 c2.05,2.05,2.05,5.36,0,7.41l-33.82,33.82c-3.3,3.3-8.95,0.96-8.95-3.71V88.97C222.7,84.3,228.35,81.96,231.65,85.26z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/Exit.da656c0c2057d2afe3603efbf47f82a2.svg";
export { ForwardRef as ReactComponent };